import axios from 'axios';

const save = (fornecedorProduto) => {
  if (fornecedorProduto.id) {
    return axios.put(`/fornecedores/produtos/${fornecedorProduto.id}`, fornecedorProduto);
  }
  return axios.post('/fornecedores/produtos', fornecedorProduto);
};

const saveCodigoInterno = fornecedorProduto => axios.put(`/fornecedores/produtos/${fornecedorProduto.id}/codigo-interno`, fornecedorProduto);

const remover = id => axios.delete(`/fornecedores/produtos/${id}`);

const get = params => axios.get('fornecedores/produtos', params);

export default {
  save,
  saveCodigoInterno,
  remover,
  get,
};
